module.exports = __webpack_public_path__ + "statics/media/aspire-logo-old.e652da77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/aspire-logo-old.svg
// module id = 1220
// module chunks = 138